import { render, staticRenderFns } from "./_bulk_delete_items_modal.vue?vue&type=template&id=38d9eb1a&scoped=true&"
import script from "./_bulk_delete_items_modal.vue?vue&type=script&lang=js&"
export * from "./_bulk_delete_items_modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38d9eb1a",
  null
  
)

export default component.exports